import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, createVNode as _createVNode, mergeProps as _mergeProps, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/audit-icon.svg'


const _withScopeId = n => (_pushScopeId("data-v-9530d7e8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "left-block" }
const _hoisted_2 = {
  key: 1,
  class: "sm:!tw-leading-[18px]"
}
const _hoisted_3 = {
  key: 0,
  class: "tw-rounded-lg tw-overflow-hidden tw-max-h-[32px] tw-max-w-[32px] tw-min-h-[32px] tw-min-w-[32px] tw-h-[32px] tw-relative sm:!tw-min-w-[29px] sm:!tw-min-h-[20px] sm:!tw-max-h-[28px]"
}
const _hoisted_4 = { class: "img-wrap tw-w-full tw-h-full md:tw-p-0" }
const _hoisted_5 = ["src"]
const _hoisted_6 = {
  key: 1,
  class: "tw-rounded-[8px] tw-overflow-hidden tw-max-h-[32px] tw-max-w-[32px] tw-min-h-[32px] tw-min-w-[32px] tw-h-[32px] tw-relative sm:!tw-min-w-[29px] sm:!tw-min-h-[20px] sm:!tw-max-h-[28px]"
}
const _hoisted_7 = {
  key: 1,
  class: "tw-rounded-[8px] tw-overflow-hidden tw-max-h-[32px] tw-max-w-[32px] tw-min-h-[32px] tw-min-w-[32px] tw-h-[32px] tw-relative sm:!tw-min-w-[29px] sm:!tw-min-h-[20px] sm:!tw-max-h-[28px]"
}
const _hoisted_8 = { class: "tw-w-full !tw-capitalize sm:!tw-hidden" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_10 = {
  key: 0,
  class: "red-dot"
}
const _hoisted_11 = { class: "modal_wrapper" }
const _hoisted_12 = { class: "main" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "loading-dots" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "dot dot-red" }),
  /*#__PURE__*/_createElementVNode("span", { class: "dot dot-blue" }),
  /*#__PURE__*/_createElementVNode("span", { class: "dot dot-green" })
], -1))
const _hoisted_14 = { class: "switching-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppIknowaLogo = _resolveComponent("AppIknowaLogo")!
  const _component_UserProfileLogo = _resolveComponent("UserProfileLogo")!
  const _component_ProfileThumbnail = _resolveComponent("ProfileThumbnail")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_WorkstationSwitchMenu = _resolveComponent("WorkstationSwitchMenu")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_AuditLogComponent = _resolveComponent("AuditLogComponent")!
  const _component_v_navigation_drawer = _resolveComponent("v-navigation-drawer")!
  const _component_v_layout = _resolveComponent("v-layout")!
  const _component_NotificationsComponent = _resolveComponent("NotificationsComponent")!
  const _component_v_stepper_item = _resolveComponent("v-stepper-item")!
  const _component_v_stepper_header = _resolveComponent("v-stepper-header")!
  const _component_v_stepper = _resolveComponent("v-stepper")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_AddressDetailsComponentModal = _resolveComponent("AddressDetailsComponentModal")!
  const _component_PropertyOwnerWorkStationModal = _resolveComponent("PropertyOwnerWorkStationModal")!
  const _component_WorkstationVerificationModal = _resolveComponent("WorkstationVerificationModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(["main-header tw-gap-8", {
      '!tw-w-full !tw-flex !tw-justify-between':
        $props.isInMapView || $setup.route?.name === $setup.TRADE_PASSPOSRT_DETAILS_ROUTE,
    }])
    }, [
      _createElementVNode("div", _hoisted_1, [
        (
          $setup.isUserWorkstationIsDefault ||
          $props.isInMapView ||
          $setup.route?.name === $setup.TRADE_PASSPOSRT_DETAILS_ROUTE
        )
          ? (_openBlock(), _createBlock(_component_AppIknowaLogo, {
              key: 0,
              class: "s540:!tw-w-[85px] md:!tw-w-[96px]"
            }))
          : (_openBlock(), _createElementBlock("span", _hoisted_2, [
              _createElementVNode("strong", null, _toDisplayString($setup.headerTitle), 1)
            ]))
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(["right-block s540:!tw-gap-[4px]", {
        '!tw-flex tw-gap-[.5rem] !tw-items-center':
          $props.isInMapView || $setup.route?.name === $setup.TRADE_PASSPOSRT_DETAILS_ROUTE,
      }])
      }, [
        _createVNode(_component_v_menu, {
          attach: "parent",
          modelValue: $setup.switchMenu,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.switchMenu) = $event)),
          "close-on-content-click": false
        }, {
          activator: _withCtx(({ props }) => [
            _createVNode(_component_v_btn, _mergeProps(props, { class: "header-profile-select" }), {
              default: _withCtx(() => [
                ($setup.activeUserWorkstation?.name === 'Default')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                      _createElementVNode("div", _hoisted_4, [
                        ($setup.userImage)
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 0,
                              src: $setup.userImage,
                              width: "100%",
                              height: "100%",
                              alt: "",
                              class: "!tw-rounded-[8px]"
                            }, null, 8, _hoisted_5))
                          : (_openBlock(), _createBlock(_component_UserProfileLogo, {
                              key: 1,
                              isRounded: false,
                              class: "tw-rounded-lg tw-overflow-hidden tw-max-h-[32px] tw-max-w-[32px] tw-min-h-[32px] tw-min-w-[32px] tw-h-[32px] tw-relative sm:!tw-min-w-[29px] sm:!tw-min-h-[20px] sm:!tw-max-h-[28px]",
                              userName: `${$setup.user?.firstName} ${$setup.user?.lastName}`
                            }, null, 8, ["userName"]))
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      ($setup.userWorkStationImage)
                        ? (_openBlock(), _createBlock(_component_ProfileThumbnail, {
                            key: 0,
                            isRounded: false,
                            src: $setup.userWorkStationImage,
                            size: "mmd",
                            mobilSize: "mmd"
                          }, null, 8, ["src"]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                            _createVNode(_component_UserProfileLogo, {
                              isRounded: false,
                              userName: 
                    $setup.activeUserWorkstation?.name === 'Default'
                      ? 'Control Center'
                      : $setup.activeUserWorkstation?.name
                  
                            }, null, 8, ["userName"])
                          ]))
                    ])),
                _createElementVNode("span", _hoisted_8, _toDisplayString($setup.activeUserWorkstation?.name === "Default"
                  ? $setup.activeUserWorkstation?.user?.firstName +
                    " " +
                    $setup.activeUserWorkstation?.user?.lastName
                  : $setup.activeUserWorkstation?.name), 1),
                _createVNode(_component_v_icon, {
                  icon: "mdi-chevron-down",
                  class: "md:!tw-ml-0 md:!tw-mr-[1px]"
                })
              ]),
              _: 2
            }, 1040)
          ]),
          default: _withCtx(() => [
            _createVNode(_component_WorkstationSwitchMenu, {
              onOnClose: $setup.onCloseSwitchMenu,
              onOnCreateWs: $setup.redirectToCreateWorkstation,
              onOnSwitchRole: $setup.onClickSwitchUserType,
              onOnWsClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.onWorkStationClick($event))),
              onOnSettingsClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.onSettingClick($event))),
              isShowTradePersonWorkstationList: $setup.isShowTradePersonWorkstationList,
              modifiedUserAllWorkStation: $setup.modifiedUserAllWorkStation,
              isShowProjectOwnerWorkstationList: $setup.isShowProjectOwnerWorkstationList
            }, null, 8, ["onOnClose", "onOnCreateWs", "onOnSwitchRole", "isShowTradePersonWorkstationList", "modifiedUserAllWorkStation", "isShowProjectOwnerWorkstationList"])
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_v_menu, { attach: "parent" }, {
          activator: _withCtx(({ props }) => [
            _createVNode(_component_v_btn, _mergeProps(props, {
              class: "settings__icon",
              size: "small",
              color: "white",
              icon: "mdi-cog"
            }), null, 16)
          ]),
          default: _withCtx(() => [
            _createVNode(_component_v_list, {
              class: _normalizeClass(["setting-menu", {
            '!tw-right-[141px] !tw-w-[182px]': $setup.isUserWorkstationIsDefault,
          }])
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.userAllSetting, (setting) => {
                  return (_openBlock(), _createBlock(_component_v_list_item, {
                    key: setting.id
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_list_item_title, {
                        class: _normalizeClass({
                'selected-setting': $setup.activeUserSetting === setting?.id,
                '!tw-hidden':
                  $setup.activeUserWorkstation?.name === 'Default' && setting.id === 2,
              }),
                        onClick: ($event: any) => ($setup.onSettingClick(setting.id))
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", null, [
                            _createVNode(_component_v_icon, {
                              icon: setting.iconName
                            }, null, 8, ["icon"]),
                            _createTextVNode(_toDisplayString(setting.name), 1)
                          ])
                        ]),
                        _: 2
                      }, 1032, ["class", "onClick"])
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ]),
              _: 1
            }, 8, ["class"])
          ]),
          _: 1
        }),
        ($setup.activeUserWorkstation?.name !== 'Default')
          ? (_openBlock(), _createBlock(_component_v_btn, {
              key: 0,
              class: "audit__icon s540:!tw-w-[32px] s540:!tw-h-[32px]",
              size: "small",
              id: "audit-icon",
              icon: "mdi-cog",
              onClick: _cache[3] || (_cache[3] = () => ($setup.drawer = !$setup.drawer))
            }, {
              default: _withCtx(() => [
                _hoisted_9
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_v_layout, { class: "auditlog__wrapper !tw-mr-[-9px] s540:!tw-mr-[-4px]" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_navigation_drawer, {
              width: "500",
              location: "end",
              modelValue: $setup.drawer,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.drawer) = $event)),
              temporary: ""
            }, {
              default: _withCtx(() => [
                ($setup.drawer)
                  ? (_openBlock(), _createBlock(_component_AuditLogComponent, {
                      key: 0,
                      onCloseModal: $setup.ShowAuditLogs
                    }, null, 8, ["onCloseModal"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_v_menu, {
          attach: "parent",
          persistent: false,
          "close-on-content-click": false,
          ref: "notificationMenuRef"
        }, {
          activator: _withCtx(({ props }) => [
            _createVNode(_component_v_btn, _mergeProps(props, {
              class: "notify__icon",
              size: "small",
              color: "white",
              icon: "mdi-bell",
              id: "notification-icon"
            }), {
              default: _withCtx(() => [
                _createVNode(_component_v_icon, {
                  icon: "mdi-bell",
                  color: "black"
                }),
                ($setup.hasUnreadNotifications)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_10))
                  : _createCommentVNode("", true)
              ]),
              _: 2
            }, 1040)
          ]),
          default: _withCtx(() => [
            _createVNode(_component_NotificationsComponent, {
              onOnClickNotification: $setup.handleOnClickNotification,
              onCloseNotificationComponent: $setup.onCloseNotificationComponent,
              onOpenVerifyModal: $setup.toggleVerifyModal
            }, null, 8, ["onOnClickNotification", "onCloseNotificationComponent", "onOpenVerifyModal"])
          ]),
          _: 1
        }, 512),
        _createVNode(_component_v_btn, {
          class: "logout__icon",
          size: "small",
          color: "white",
          icon: "mdi-logout",
          onClick: $setup.onClickLogout,
          title: "Logout"
        }, null, 8, ["onClick"])
      ], 2)
    ], 2),
    _createVNode(_component_v_dialog, {
      width: "500px",
      modelValue: $setup.loading,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.loading) = $event)),
      class: "modal_box action-modal",
      persistent: ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("main", _hoisted_12, [
            _createElementVNode("div", null, [
              _hoisted_13,
              _createElementVNode("p", _hoisted_14, _toDisplayString($setup.switchingText), 1),
              _createVNode(_component_v_stepper, {
                class: "onboard-stepper",
                modelValue: $setup.currentSelectedTab.name,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.currentSelectedTab.name) = $event))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_stepper_header, { class: "onboard-stepper__header" }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.tabListItems, (step, index) => {
                        return (_openBlock(), _createBlock(_component_v_stepper_item, {
                          class: "onboard-stepper__item",
                          key: index,
                          value: step.name
                        }, null, 8, ["value"]))
                      }), 128))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    ($setup.isOpenAddressModal)
      ? (_openBlock(), _createBlock(_component_AddressDetailsComponentModal, {
          key: 0,
          onOnClickCloseTab: $setup.toggleAddressModal
        }, null, 8, ["onOnClickCloseTab"]))
      : _createCommentVNode("", true),
    ($setup.isShowPropertyOwnerWorkStationModal)
      ? (_openBlock(), _createBlock(_component_PropertyOwnerWorkStationModal, {
          key: 1,
          onOnClickCloseTab: $setup.onClickClosePOWorkstationModal
        }, null, 8, ["onOnClickCloseTab"]))
      : _createCommentVNode("", true),
    ($setup.isOpenVerifyModal)
      ? (_openBlock(), _createBlock(_component_WorkstationVerificationModal, {
          key: 2,
          onClickCloseTab: $setup.toggleVerifyModal
        }, null, 8, ["onClickCloseTab"]))
      : _createCommentVNode("", true)
  ], 64))
}